var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"cont_error"},[_c('h5',[_vm._v("Error")]),_c('h1',[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t("error.404-desc")))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('button.home')))])],1),_vm._l((_vm.bubles),function(buble,id){return _c('span',{key:id})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }